import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { UserService } from '../../services/user.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
import { Dropdown } from "primeng/dropdown";
import { environment } from 'src/environments/environment';
import * as moment from "moment";
import { saveAs } from 'file-saver/src/FileSaver';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  styles: [`
        :host ::ng-deep .p-datatable-gridlines p-progressBar {
            width: 100%;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})
export class AccountComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public hide: boolean = true;
  errorMessage = '';
  statuses: any[];
  searchBy: any[];
  totalRecords: 0;
  adminRoleId;
  public item: any[] = [];
  loading: boolean;
  paginationOption;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  downloadFlg: boolean;
  downloadUserList: any;
  searchby;
  id:any;
  gstDataList:any=[];
  gstDataFullList:any=[];
  gstdata:any=[];
  allgstdatalist:any=[];
  gstList:any=[];
  paymentDetails:any=[];
  payAcaId:any;
  academyId:any;
  status:any;
  payMentLis:any;
  gstDataLists:any=[];
  paymentList:any=[];
  listOfData:any;
  startDate: Date;
  endDate: Date;
  downloadAcademiesList: any;
  calvalue: Date;
  ucalvalue: Date;
  dcalvalue: Date;
  yearRange;
  wdcalvalue

  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  constructor(private userService: UserService) { }


  ngOnInit(): void {
    this.paginationOption = environment.pagination;
    this.downloadFlg = false;
    
    
    this.searchBy = [
      { label: "Created On", value: "created_at" },
      //{ label: "Last Modified On", value: "updated_at" },
    ];
  
  }
  
  loadUsers(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;

    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }

    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (event.filters?.["gstin"]) params += "&filterBygstin=" + event.filters["gstin"].value;
    if (event.filters?.["name"]) params += "&filterByname=" + event.filters["name"].value;
    if (event.filters?.["address"]) params += "&filterByClientAddress=" + event.filters["address"].value;
    if (event.filters?.["cityname"]) params += "&filterByCityName=" + event.filters["cityname"].value;
    if (event.filters?.["statename"]) params += "&filterByStateName=" + event.filters["statename"].value;
    if (event.filters?.["zipcode"]) params += "&filterByPinCode=" + event.filters["zipcode"].value;

    if (this.searchby && this.startDate && this.endDate) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    if (this.downloadFlg == false) {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      if (params) query += params;
    } else {
      if (params) query += params;
    }

    if (event.sortField && event.sortOrder) {
      let orderBy = event.sortOrder == 1 ? "DESC" : "ASC";
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }

    this.userService.getGstDataListAll(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.gstDataList = data.data;
        this.totalRecords = data.totalCount;
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  addColumns() {
        this.hide = false;

    }

    /**
    * Use to remove more columns in the table.
    */
    removeColumns() {
        this.hide = true;
    }
  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    var query = "?filterByDisable=false";
    var params = "";
    const event = this.lastTableLazyLoadEvent;

    if (event?.filters?.["gstin"]) params += "&filterBygstin=" + event.filters["gstin"].value;
    if (event?.filters?.["name"]) params += "&filterByname=" + event.filters["name"].value;
    if (event?.filters?.["address"]) params += "&filterByClientAddress=" + event.filters["address"].value;
    if (event?.filters?.["cityname"]) params += "&filterByCityName=" + event.filters["cityname"].value;
    if (event?.filters?.["statename"]) params += "&filterByStateName=" + event.filters["statename"].value;
    if (event?.filters?.["zipcode"]) params += "&filterByPinCode=" + event.filters["zipcode"].value;

    if (this.searchby && this.startDate && this.endDate) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    if (params) query += params;

    this.userService.getGstDataListAll(query).pipe(takeUntil(this.destroy$)).subscribe(data => {
      var propertiesRemove = ['id', 'academyId', 'orderId', 'receiptId', 'amount', 'currency', 
        'transactionDate', 'expiryDate', 'status', 'membershipType', 'paymentId', 
        'signature', 'invoiceFile', 'isIgst', 'isGst', 'gstDataList'];
      
      let exportList = JSON.parse(JSON.stringify(data.data));
      exportList.forEach(item => {
        propertiesRemove.forEach(prop => delete item[prop]);
      });

      import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(exportList);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });
        this.saveAsExcelFile(excelBuffer, "GSTSalesData");
        this.downloadFlg = false;
      });
    }, err => {
      this.errorMessage = err.error.message;
      this.downloadFlg = false;
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.dt.filter("", "name", "contains");
    this.dt.filter("", "cityname", "contains");
    this.dt.filter("", "gstin", "contains");
    this.dt.filter("", "statename", "contains");
    this.dt.filter("", "address", "contains");
    this.dt.filter("", "zipcode", "contains");
    this.dt.filter("", "created_at", "dateIs");
    this.dt.filter("", "createdby", "contains");
    this.dt.filter("", "updated_at", "dateIs");
    this.dt.filter("", "updatedby", "contains");
    this.calvalue = null;
    this.ucalvalue = null;
    this.dcalvalue = null;
    this.wdcalvalue = null;
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = "";
    }
  }

 downloadPdf(invoiceFile) {
        window.open(invoiceFile);
    }


    ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
    

}
